(function () {

  'use strict';

  function pxSnmpConfigurationSelector($timeout, SnmpConfigurationService, SnmpConfigurationsPaging) {
    return {
      restrict: 'EA',
      scope: {
        networkId: '=',
        onItemSelected: '&',
        allowCreateNew: '=',
        onClickCreateNew: '&'
      },
      templateUrl: 'app/components/sites/discoverPrinters/snmpListSmall/snmpConfigurationSelector.template.html',
      link: function (scope) {
        scope.loading = false;
        scope.snmpConfigurations = [];
        scope.paging = new SnmpConfigurationsPaging();
        scope.paging.pagingCriteria.networkIds = scope.networkId ? [scope.networkId] : null;
        scope.paging.pagingCriteria.global = scope.networkId ? null : true;
        scope.totalPages = 0;
        scope.timeout = null;

        scope.getSnmpConfigurationsFirstPage = function () {
          scope.loading = true;
          scope.paging.pagingCriteria.page = 0;
          SnmpConfigurationService.getSnmpConfigurationsPaged(scope.paging).then(function (response) {
            scope.snmpConfigurations = SnmpConfigurationService.extractSnmpConfigurationsFromResponse(response);
            scope.totalPages = response.data.page.totalPages;
            scope.loading = false;
          }).catch(function(error){
            scope.loading = false;
          });
        };

        scope.getSnmpConfigurationsNextPage = function () {
          scope.loading = true;
          scope.paging.pagingCriteria.page += 1;
          SnmpConfigurationService.getSnmpConfigurationsPaged(scope.paging).then(function (response) {
            const snmpConfigurations = SnmpConfigurationService.extractSnmpConfigurationsFromResponse(response);
            scope.snmpConfigurations.push(...snmpConfigurations);
            scope.totalPages = response.data.page.totalPages;
            scope.loading = false;
          }).catch(function(error){
            scope.loading = false;
          });
        };

        scope.selectSnmpConfiguration = function (event, snmpConfiguration) {
          event.stopPropagation();
          scope.onItemSelected({ snmpConfig: snmpConfiguration });
        };

        scope.createSnmpConfiguration = function (event) {
          event.stopPropagation();
          scope.onClickCreateNew({ event: event });
        };

        scope.closePopup = function (event) {
          scope.onItemSelected({ snmpConfig: null });
        };

        function scrollHandler(event) {
          if (!scope.loading && scope.totalPages > scope.paging.pagingCriteria.page + 1) {
            const element = event.currentTarget;
            if (Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop) <= 1) {
              if (scope.timeout) {
                $timeout.cancel(scope.timeout);
              }
              scope.timeout = $timeout(function () {
                scope.timeout = null;
                scope.getSnmpConfigurationsNextPage();
              }, 300);
            }
          }
        }

        function attachScrollHandler() {
          angular.element('.pagination-small-results').on('scroll', scrollHandler);
        }

        function detachScrollHandler() {
          angular.element('.pagination-small-results').off('scroll', scrollHandler);
        }

        (function () {
          scope.getSnmpConfigurationsFirstPage();
          attachScrollHandler();
        })();

        scope.$on('$destroy', function () {
          detachScrollHandler();
        });

        // TOOLTIP STUFF
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            const element = angular.element('.context-content-container')[0];
            position.startX -= element.offsetLeft;
            position.startY -= element.offsetTop;
            switch (tooltipScope) {
              case 'snmpTooltip':
                showSnmpTooltip(position, context);
                break;
            }
          } else {
            clearTooltip();
          }
        };

        function showSnmpTooltip(position, context) {
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 },
            contextMenu: true
          };
          scope.tooltipContent = {
            title: context.info.name,
            type: 'snmpDescription',
            icon: 'icon-connection',
            snmpConfiguration: context
          };
        }

        function clearTooltip() {
          scope.tooltipObject = null;
          scope.tooltipContent = null;
        }

      }
    };
  }

  pxSnmpConfigurationSelector.$inject = ['$timeout', 'SnmpConfigurationService', 'SnmpConfigurationsPaging'];

  angular
    .module('printix-admin')
    .directive('pxSnmpConfigurationSelector', pxSnmpConfigurationSelector);

})();
